import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";

interface AddMcpServerModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  name: string;
  serverUrl: string;
  accessToken: string;
  onNameChange: (value: string) => void;
  onServerUrlChange: (value: string) => void;
  onAccessTokenChange: (value: string) => void;
  isSubmitting: boolean;
  errorMessage?: string | null;
}

export const AddMcpServerModal: React.FC<AddMcpServerModalProps> = ({
  open,
  onClose,
  onSubmit,
  name,
  serverUrl,
  accessToken,
  onNameChange,
  onServerUrlChange,
  onAccessTokenChange,
  isSubmitting,
  errorMessage,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add Integration</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            We manage these integrations through the MCP protocol. Provide a
            name and URL. If access token is empty we will try OAuth.
          </Typography>

          {errorMessage && <Alert severity="error">{errorMessage}</Alert>}

          <TextField
            label="Connection Name"
            value={name}
            onChange={(event) => onNameChange(event.target.value)}
            size="small"
            fullWidth
          />
          <TextField
            label="MCP Server URL"
            value={serverUrl}
            onChange={(event) => onServerUrlChange(event.target.value)}
            placeholder="https://your-mcp-server.example.com/mcp"
            size="small"
            fullWidth
          />
          <TextField
            label="Access Token (Optional)"
            value={accessToken}
            onChange={(event) => onAccessTokenChange(event.target.value)}
            type="password"
            size="small"
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onSubmit} disabled={isSubmitting}>
          {isSubmitting ? "Connecting..." : "Connect"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
